import { get, post } from '../paymentLinkHttp'

class easyCollectAPI {

    static getCookie(name) {
        const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return cookieValue ? cookieValue.pop() : '';
    }
    static get_link_details = (slug) => {
        let endpoint = `easy-collect/${slug}/`
        return get(endpoint);
    }
    static call_gateway = (slug) => {
        const csrfToken = this.getCookie('csrftoken');
        const headers = { 'X-CSRFToken': csrfToken, 'Content-Type': 'application/json' };
        let endpoint = `easy-collect/${slug}/`;
        return post(endpoint, {}, headers)
    }
    static get_txn_details = (url,txn_id) => {
        let endpoint = `easy-collect/response/${url}/${txn_id}/`
        return get(endpoint);
    }
}
export default easyCollectAPI